import React from "react";
import BasicButton from "../components/BasicButton";

export default () =>
    <div className="mini-page">
        <header>
            <h1>Pahoittelut, sivua ei löytynyt</h1>
        </header>
        <footer>
            <div className={"btn-set_center"}>
                <BasicButton
                    btnClass={"primary"}
                    label={"Alkuun"}
                    icon={"arrow-left"}
                    href={"/"}
                />
            </div>
        </footer>
    </div>
